export default __webpack_public_path__ + "3231cad.png";